import resolveConfig from "tailwindcss/resolveConfig";
import Loader from "../components/Loader.jsx";
import React from "react";

export function shuffleArray(array) {
  for (var i = array.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    var temp = array[i];
    array[i] = array[j];
    array[j] = temp;
  }
}

export const tailwindConfig = () => {
  // Tailwind config
  return resolveConfig("./src/css/tailwind.config.js");
};

export function isValidInput(input) {
  const hasMinLength = input.length >= 8;
  const checks = [
    /[A-Z]/, // capital letters
    /[a-z]/, // lowercase letters
    /[0-9]/, // numbers
    /[^A-Za-z0-9]/, // symbols
  ];

  const passedChecks = checks.reduce(
    (acc, regex) => acc + regex.test(input),
    0
  );

  return hasMinLength && passedChecks >= 3;
}

export const hexToRGB = (h) => {
  let r = 0;
  let g = 0;
  let b = 0;
  if (h.length === 4) {
    r = `0x${h[1]}${h[1]}`;
    g = `0x${h[2]}${h[2]}`;
    b = `0x${h[3]}${h[3]}`;
  } else if (h.length === 7) {
    r = `0x${h[1]}${h[2]}`;
    g = `0x${h[3]}${h[4]}`;
    b = `0x${h[5]}${h[6]}`;
  }
  return `${+r},${+g},${+b}`;
};

export const formatValue = (value) => {
  return Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
    // notation: "compact",
  }).format(value);
};

export function getTimezoneOffsetMinutes(timezone) {
  const now = new Date();

  // Get the UTC timestamp
  const laTime = new Intl.DateTimeFormat("en-US", {
    timeZone: "America/Los_Angeles",
    hour12: false,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  }).format(now)
  // Parse LA time to get its timestamp
  const [dateLA, timeLA] = laTime.split(", ");
  const [monthLA, dayLA, yearLA] = dateLA.split("/");
  const [hoursLA, minutesLA, secondsLA] = timeLA.split(":");

  const laTimestamp = Date.UTC(
    parseInt(yearLA, 10),
    parseInt(monthLA, 10) - 1,
    parseInt(dayLA, 10),
    parseInt(hoursLA, 10),
    parseInt(minutesLA, 10),
    parseInt(secondsLA, 10),
  );



  // Format the time in the given timezone
  const localTime = new Intl.DateTimeFormat("en-US", {
    timeZone: timezone,
    hour12: false,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  }).format(now);

  // Parse the local time to get its timestamp
  const [date, time] = localTime.split(", ");
  const [month, day, year] = date.split("/");
  const [hours, minutes, seconds] = time.split(":");

  const localTimestamp = Date.UTC(
    parseInt(year, 10),
    parseInt(month, 10) - 1,
    parseInt(day, 10),
    parseInt(hours, 10),
    parseInt(minutes, 10),
    parseInt(seconds, 10),
  );

  // Calculate the offset in minutes
  const offsetMinutes = (laTimestamp - localTimestamp) / 60000;

  return Math.round(offsetMinutes);
}

// function to format a string to at most 2 significant digits
export const formatValue2 = (value) =>
  Intl.NumberFormat("en-US", {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  }).format(value);

export const formatThousands = (value) =>
  Intl.NumberFormat("en-US", {
    maximumSignificantDigits: 3,
    notation: "compact",
  }).format(value);

export const formatPhoneNumber = (phoneNumberString) => {
  const cleaned = ("" + phoneNumberString).replace(/\D/g, "");
  const match = cleaned.match(/^1?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return "(" + match[1] + ") " + match[2] + "-" + match[3];
  }
  return null;
};

export function parseAddress(place) {
  var address = {};
  var componentForm = {
    street_number: "short_name",
    route: "long_name",
    locality: "long_name",
    administrative_area_level_1: "short_name",
    country: "long_name",
    postal_code: "short_name",
  };
  var typeMap = {
    street_number: "number",
    route: "street",
    locality: "city",
    administrative_area_level_1: "state",
    postal_code: "zip",
  };

  if (!place.address_components) return;

  for (var i = 0; i < place.address_components.length; i++) {
    var addressType = place.address_components[i].types[0];
    if (typeMap[addressType]) {
      var val = place.address_components[i][componentForm[addressType]];
      address[typeMap[addressType]] = val;
    }
  }
  if (address.street) {
    address.address = [address.number, address.street]
      .filter(Boolean)
      .join(" ");
  }
  delete address.number;
  delete address.street;

  address.location = {
    coordinates: [place.geometry.location.lng(), place.geometry.location.lat()],
    type: "Point",
  };
  return address;
}

const OrderStatusEnum = {
  CANCELLED:-4,
  EXPIRED:-3,
  DECLINED: -2,
  REJECTED: -1,
  PENDING: 0,
  ACCEPTED: 1,
  IN_PROGRESS: 2,
  COMPLETED: 3,
  FAILED: 4,
  REFUNDED: 5,
  SCHEDULED: 6,
  PICKED_UP: 7,
  SOFT_CANCEL: 8,
  GROUP_ORDER: 10, // This state only exists for GroupedOrders, because order_status is a required field
  HELD: 11
};
export const OrderStatusInverseEnum = (() => {
  return Object.keys(OrderStatusEnum).reduce((acc, key) => {
    acc[OrderStatusEnum[key]] = key;
    return acc;
  }, {});
})();
export const statusColor = (status, queueState) => {
  if (queueState === 4) {
    return "bg-red-100 dark:bg-red-400/30 text-red-600 dark:text-red-400";
  }
  switch (status) {
    case "ACCEPTED":
      // pink
      return "bg-rose-50 dark:bg-rose-400/30 text-rose-500 dark:text-rose-400";

    case "IN_PROGRESS":
      // blue
      return "bg-sky-100 dark:bg-sky-400/30 text-sky-600 dark:text-sky-400";
    case "COMPLETED":
      return "bg-emerald-100 dark:bg-emerald-400/30 text-emerald-600 dark:text-emerald-400";
    case "PENDING":
      // yellow
      return "bg-amber-100 dark:bg-amber-400/30 text-amber-600 dark:text-amber-400";
    case "DECLINED":
      return "bg-red-100 dark:bg-red-400/30 text-red-600 dark:text-red-400";
    case "REJECTED":
      return "bg-red-100 dark:bg-red-400/30 text-red-600 dark:text-red-400";
    case "FAILED":
    case "EXPIRED":
    case "CANCELLED":
    case "REFUNDED":
      return "bg-red-100 dark:bg-red-400/30 text-red-600 dark:text-red-400";
    case "SCHEDULED":
      return "bg-amber-100 dark:bg-amber-400/30 text-amber-600 dark:text-amber-400";

      // return "bg-slate-100 dark:bg-slate-700 text-slate-500 dark:text-slate-400";
    case "PICKED_UP":
      // purple
      return "bg-violet-100 dark:bg-violet-400/30 text-violet-600 dark:text-violet-400";
    case "SOFT_CANCEL":
      return "bg-slate-100 dark:bg-slate-700 text-slate-500 dark:text-slate-400";
    default:
      return "bg-slate-100 dark:bg-slate-700 text-slate-500 dark:text-slate-400";
  }
};

/**
 * Returns the median of the input array after filtering out values more than 3 standard deviations from the mean.
 * @param {number[]} prices
 * @returns {number}
 */
export function getFilteredMedianPrice(prices) {
  if (!prices || prices.length === 0) return 0;
  const mean = prices.reduce((a, b) => a + b, 0) / prices.length;
  const std = Math.sqrt(prices.reduce((a, b) => a + Math.pow(b - mean, 2), 0) / prices.length);
  const filtered = prices.filter(v => Math.abs(v - mean) <= 3 * std);
  const sorted = filtered.sort((a, b) => a - b);
  if (sorted.length === 0) return 0;
  if (sorted.length % 2 === 1) {
    return sorted[Math.floor(sorted.length / 2)];
  } else {
    return (sorted[sorted.length / 2 - 1] + sorted[sorted.length / 2]) / 2;
  }
}

/**
 * Returns a price indicator type string based on the price difference percent.
 * @param {number} priceDifferencePercent
 * @returns {'match'|'higher'|'much-higher'|'lower'|'much-lower'|'gray'}
 */
export function getPriceIndicatorType(priceDifferencePercent) {
  if (typeof priceDifferencePercent !== 'number' || isNaN(priceDifferencePercent)) return 'gray';
  if (Math.abs(priceDifferencePercent) <= 10) return 'match';
  if (priceDifferencePercent > 10 && priceDifferencePercent <= 20) return 'higher';
  if (priceDifferencePercent > 20) return 'much-higher';
  if (priceDifferencePercent < -10 && priceDifferencePercent >= -20) return 'lower';
  if (priceDifferencePercent < -20) return 'much-lower';
  return 'gray';
}

export const GetCardIcon = ({ brand }) => {
  const brandMap = {
    "american express": "amex",
    "diners club": "diners",
    discover: "discover",
    jcb: "jcb",
    mastercard: "mastercard",
    unionpay: "generic",
    visa: "visa",
    unknown: "generic",
    apple_pay: "apple-pay",
    google_pay: "google-pay",
  };

  return (
    "https://cdn.saucey.com/direct/web/payment-logos/" +
    (brandMap[brand] ?? "generic") +
    ".svg"
  );
};


export const onboardChecklistItems = [
  { 
    key: "inviteTeammates", 
    label: "Invite Teammates",
    description: "Add team members to help manage your store operations",
    link: "/settings/users",
    skipInProgress: true,
    required: false,
  },
  { 
    key: "editBusinessDetails", 
    label: "Edit Business Details",
    description: "Update your business information store details",
    link: "/settings/business",
    required: true,
  },
  { 
    key: "uploadDocuments", 
    label: "Upload Documents",
    description: "Submit required business licenses and verification documents",
    link: "/settings/business#documents",
    skipInProgress: true,
    required: true,
  },
  { 
    key: "editStoreSettings", 
    label: "Edit Store Settings",
    description: "Configure website settings, order, delivery and fee options",
    link: "/settings/store",
    markComplete: true,
    required: true,
  },
  { 
    key: "updateStoreHours", 
    label: "Update Store Hours",
    description: "Set your store's operating hours and availability",
    link: "/settings/hours",
    skipInProgress: true,
    required: true,
  },
  { 
    key: "setupMenu", 
    label: "Set Up Menu",
    description: "Add products, categories, and pricing to your online menu",
    link: "/catalog/products",
    required: true,
  },
  { 
    key: "setupBanking", 
    label: "Set Up Banking Information",
    description: "Connect your bank account to receive payments and payouts",
    prerequisite: "editBusinessDetails",
    link: "/settings/finance",
    required: true,
  },
  {
    key: "setupBilling",
    label: "Set Up Billing",
    description: "Set up your billing information and payment methods",
    link: "/settings/billing",
    skipInProgress: true,
    required: true,
  }
];

export function findMerchantLocationByStoreId(merchants, storeId) {
  if (storeId == null || !merchants?.length) return null;
  const sid = String(storeId);
  for (const merchant of merchants) {
    const location = merchant.locations?.find(
      (loc) => String(loc.store_id) === sid
    );
    if (location) return { merchant, location };
  }
  return null;
}